import { Box } from '@atgfr8/atg-ui-tailwind';
import { AtgLoader } from '@components/AtgLoader';
import { lazy, Suspense } from 'solid-js';

const SavedQuotes = lazy(() => import('@views/ltl/SavedQuotes'));

const LtlSavedQuotes = () => {
  return (
    <Box class="h-[calc(100vh-210px)]">
      <Suspense fallback={<AtgLoader />}>
        <SavedQuotes isCustomerSaveQuote={true} />
      </Suspense>
    </Box>
  );
};

export default LtlSavedQuotes;
